import classNames from 'classnames';
import React, {ReactNode} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

import {MenuWidth} from './MenuConstants';

interface MenuPopoverProps {
  children: ReactNode;
  className?: string;
  dataTestAttrs?: DataTestAttrs;
  dropLeft?: boolean;
  width?: MenuWidth;
}

function MenuPopover(props: MenuPopoverProps): JSX.Element {
  return (
    <div
      {...getTestProps(props.dataTestAttrs)}
      className={classNames(
        'menu',
        props.className,
        props.width && `menu--${props.width}Width`,
        props.dropLeft && 'menu--dropLeft'
      )}
    >
      {props.children}
    </div>
  );
}

export default MenuPopover;
